import { render, staticRenderFns } from "./info-tab.vue?vue&type=template&id=feca92ba"
import script from "./info-tab.vue?vue&type=script&lang=js"
export * from "./info-tab.vue?vue&type=script&lang=js"
import style0 from "./info-tab.vue?vue&type=style&index=0&id=feca92ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports